import { TChartType, TDeviceAttribute } from '../../types'

export class AttributesConfig {
    private readonly attributesConfig: Map<string, TDeviceAttribute>

    public constructor(data: { [key: string]: { [key: string]: string | boolean } }) {
        const config: Map<string, TDeviceAttribute> = new Map<string, TDeviceAttribute>()

        Object.keys(data).forEach((key: string) => {
            const deviceAttributeData = data[key]
            const deviceAttributeItem: TDeviceAttribute = {
                displayName: (deviceAttributeData.displayName as string) || '',
                icon: (deviceAttributeData.icon as string) || '',
                type: (deviceAttributeData.type as string) || '',
                unit: (deviceAttributeData.unit as string) || '',
                trueValue: (deviceAttributeData.trueValue as string) || '',
                falseValue: (deviceAttributeData.falseValue as string) || '',
                color: (deviceAttributeData.color as string) || '',
                chartType: (deviceAttributeData.chartType as TChartType) || 'line',
                yAxisId: (deviceAttributeData.yAxisId as string) || '',
                clickable: (deviceAttributeData.clickable as boolean) || false,
                yMin: AttributesConfig.getYMin(key),
                yMax: AttributesConfig.getYMax(key)
            }

            config.set(key, deviceAttributeItem)
        })

        this.attributesConfig = config
    }

    private static getYMin(key: string): number | undefined {
        switch (key) {
            case 'tempProbe': {
                return -200
            }
            case 'temperature_c': {
                return -25
            }
            case 'orientation': {
                return 0
            }
            case 'humidity': {
                return 0
            }
            case 'battery': {
                return 0
            }
            case 'pressure': {
                return 55000
            }
            case 'shock': {
                return 0
            }
            case 'light': {
                return 0
            }
            case 'cycle': {
                return 0
            }
            default:
                return undefined
        }
    }

    private static getYMax(key: string): number | undefined {
        switch (key) {
            case 'tempProbe': {
                return -100
            }
            case 'temperature_c': {
                return 50
            }
            case 'orientation': {
                return 180
            }
            case 'humidity': {
                return 100
            }
            case 'battery': {
                return 100
            }
            case 'pressure': {
                return 105000
            }
            case 'shock': {
                return 20
            }
            case 'light': {
                return 100
            }
            case 'cycle': {
                return 50000
            }
            default:
                return undefined
        }
    }

    public getAttributesConfig(): Map<string, TDeviceAttribute> {
        return this.attributesConfig
    }
}
